import React from 'react';
import * as _ from 'lodash';
import { MACHINERY_TYPES } from '../../../utilities/constants';
import { FormElement, FormDropdownRadio } from '../../CommonFormComponents';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
export class MachineryTypeDropdown extends React.Component {
  constructor(props) {
    super(props);

    let options = {};
    _.map(MACHINERY_TYPES, type => {
      options[type.id] = type;
    });

    this.state = {
      opened: false,
      selected: null,
      options,
      error: '',
      temporarySelected: null,
      selectedName: '',
      temporarySelectedName: '',
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.resetSelected = this.resetSelected.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.selected) {
      this.setState({
        selected: nextProps.value,
        temporarySelected: nextProps.value,
        selectedName: nextProps.name || '',
        temporarySelectedName: nextProps.name || '',
      });
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.resetSelected();

    // フォーカスアウト時のバリデーション
    if (this.props.validate) {
      this.props.validate('machinery_type');
    }
  };

  /**
   * 値を変更前に戻す
   */
  resetSelected() {
    const state = this.state;
    state.opened = false;
    state.temporarySelected = state.selected;
    this.setState(state);
  }

  handleOpen = () => {
    const state = this.state;
    state.opened = !this.state.opened;
    // 初期化
    if (state.opened) {
      state.opened = true;
      state.temporarySelected = state.selected;
      this.setState(state);
    } else {
      this.resetSelected();

      // フォーカスアウト時のバリデーション
      if (this.props.validate) {
        this.props.validate('machinery_type');
      }
    }
  };

  handleSelectedRow = id => {
    const state = { ...this.state };
    state.temporarySelected = id;
    const selectedRow = _.find(state.options, { id });
    state.temporarySelectedName = selectedRow.name;
    this.setState(state, () => {
      this.setValue();
    });
  };

  setValue = () => {
    const state = { ...this.state };
    state.selected = state.temporarySelected;
    state.selectedName = state.temporarySelectedName;
    this.setState(state);

    this.props.set('machinery_type', state.selected);
    this.props.set('machinery_id', null);
    this.setState({ opened: false });
    if (this.props.validate) {
      this.props.validate('machinery_type', {
        machinery_type: state.selected,
        machinery_id: null,
      });
    }
  };

  render() {
    const getName = () => {
      let name = '機材種別を選択';

      const option = _.find(this.state.options, {
        id: this.state.selected,
      });
      if (option) {
        name = option.name;
      } else {
        name = this.state.selectedName || name;
      }

      return name;
    };
    if (this.props.isFormListDefault && this.props.readOnly) {
      return (
        <FormElement>
          <div>{getName()}</div>
        </FormElement>
      );
    }
    return (
      <FormElement validate={this.props.error}>
        <div id='form-dropdown' className='dropdown-multi-select '>
          {this.props.readOnly ? (
            <input disabled type='text' value={getName()} />
          ) : (
            <div ref={this.parent}>
              <div
                className={`dropdown-multi-select__header ${
                  this.state.opened ? 'show' : ''
                }`}
              >
                <div
                  id='form-dropdown-btn'
                  href=''
                  className='dropdown-select'
                  onClick={this.handleOpen}
                >
                  <span className='dropdown-select__txt'>{getName()}</span>
                </div>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <div className='dropdown-single-select__scroll'>
                        <ul className='single-select'>
                          {_.map(MACHINERY_TYPES, (type, index) => (
                            <FormDropdownRadio
                              key={index}
                              option={type}
                              checked={this.state.temporarySelected === type.id}
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-machinery-type'
                            />
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/MachineryType.jsx